module.exports = __webpack_public_path__ + "img/account-managers.02e560b5.svg";